import styled from "styled-components";

export const ListContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-top: 2rem;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      background: #f8f9fa;
      border-bottom: 2px solid #e9ecef;

      th {
        padding: 1rem;
        text-align: left;
        font-weight: 600;
        color: #495057;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        white-space: nowrap;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #e9ecef;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: #f8f9fa;
        }

        &:last-child {
          border-bottom: none;
        }

        td {
          padding: 1rem;
          color: #212529;
          font-size: 0.875rem;
          vertical-align: middle;
        }
      }
    }
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  white-space: nowrap;

  ${(props) => {
    switch (props.status) {
      case "approved":
        return `
          background-color: #d4edda;
          color: #155724;
        `;
      case "pending":
        return `
          background-color: #fff3cd;
          color: #856404;
        `;
      case "rejected":
        return `
          background-color: #f8d7da;
          color: #721c24;
        `;
      default:
        return `
          background-color: #e9ecef;
          color: #495057;
        `;
    }
  }}
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
`;

export const ButtonAction = styled.button`
  padding: 0.5rem;
  color: #6c757d;
  font-size: 1rem;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  &:hover {
    background-color: #f8f9fa;
    color: #203b34;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Icon = styled.i`
  font-size: 1rem;
`;

export const Option = styled.li`
  padding: 10px;
`;

export const ListOptions = styled.ul`
  background: #203b34;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
  cursor: pointer;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  background: #fafbfc;
`;

export const PaginationInfo = styled.div`
  color: #6c757d;
  font-size: 0.875rem;
`;

export const PaginationControls = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const PageButton = styled.button`
  padding: 0.5rem 0.75rem;
  border: 1px solid #dee2e6;
  background: white;
  color: #495057;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #f8f9fa;
    border-color: #203b34;
    color: #203b34;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.active {
    background: #203b34;
    color: white;
    border-color: #203b34;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 2rem;
  color: #6c757d;

  .icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    opacity: 0.5;
  }

  h4 {
    margin-bottom: 0.5rem;
    color: #495057;
  }

  p {
    font-size: 0.875rem;
  }
`;
